import { Injectable, Injector } from '@angular/core';
import { SortOption } from '@core';
import { Observable } from 'rxjs';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';

@Injectable()
export class CsListService extends DocListBaseService {
  url = 'api/cashsales/list';
  expandProperties =
    'Customer($select=Code),Currency($select=Code),Agent($select=Code),Term($select=Code)';
  override searchColumns: string[] = [
    'DocCode',
    'Description',
    'CustomerName',
    'Customer/Code',
    'CustomerName',
    'Agent/Code',
    'Term/Code',
  ];
  sortOptions: SortOption[] = [
    { title: 'Date', sort: 'docDate' },
    { title: 'Doc #', sort: 'docCode' },
    { title: 'Customer #', sort: 'Customer/Code' },
    { title: 'Customer Name', sort: 'CustomerName' },
    { title: 'Agent #', sort: 'Agent/Code' },
    { title: 'Amount', sort: 'netTotalAmount' },
    { title: 'Ref. No', sort: 'referenceNo' },
    { title: 'Validated On', sort: 'validateOn' }
  ];

  override onAction(action: string, data: any): Promise<boolean> {
    if (action === 'matchToAROR') {
      return this.confirmValidToKnockoff(data.map((x: any) => x.id));
    }
    if (action === 'bulkApprove') {
      return this.confirmApprove(data.map((x: any) => x.id));
    }
    return super.onAction(action, data);
  }

  batchDelete(ids: any[]): Observable<any> {
    return this.http.delete('api/cashsales', null, {
      body: { ids: ids }
    });
  }
  constructor(injector: Injector) {
    super(injector);
  }

  confirmValidToKnockoff(ids: any[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .post('api/cashsales/IsValidKnockedoff', { ids: ids }, { _silent: true })
        .subscribe(res => {
          if(res > 0) {
            this.match(ids, res);
            resolve(true);
          }
          else {
            if(res === -1){
              this.msg.error('<b>Cash Sale(s) is already knocked-off.')
            }
            if(res === -2){
              this.msg.error('<b>Cash Sale(s) that have been selected have different customer IDs.')
            }
            if(res === -3){
              this.msg.error('<b>Cash Sale(s) that are selected should be Post to AR.')
            }
            reject();
          }
        });
    });
  }

  match(row: any[], customerId: any){
    this.router.navigate(['/ar/or/detail/0'], { queryParams: { customerId: customerId, docType: 'CS', toKnockoffBatch: row } });
  }

  confirmApprove(ids: any[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post('api/cashsales/ApproveBulk', { ids: ids })
      .subscribe({
        next: (res) => {
          if(res > 0) {
            resolve(true);
          }
          else {
            reject();
          }
        },
        error: (error) => {
          reject();
        }
      });
    });
  }
}
